import { getEnv } from '@luna/env';

import type { BankMessage } from './BankMessagesTypes';
import { BankMessageFlag } from './BankMessagesTypes';

export function getBankMessagesUrl(): string {
    return `${getEnv().localApiBaseUrl}my/messages`;
}

export function getBankMessageUrl(id: string): string {
    return `${getBankMessagesUrl()}/${id}`;
}

export function isBankMessageUnread(flags: BankMessageFlag[] = []): boolean {
    return flags.includes(BankMessageFlag.UNREAD);
}

export function isBankMessageDeletable(flags: BankMessageFlag[] = []): boolean {
    return flags.includes(BankMessageFlag.DELETABLE);
}

function removeUnreadFlag(flags: BankMessageFlag[] = []): BankMessageFlag[] {
    return flags.filter((flag) => flag !== BankMessageFlag.UNREAD);
}
export function removeUnreadFlagFromMessage(message: BankMessage): BankMessage {
    return {
        ...message,
        flags: removeUnreadFlag(message.flags),
    };
}
